import React from 'react';
import StockChart from '../components/Chart';
import { useRankingFluctuationAfterHours } from '../hooks/useRankingFluctuationAfterHours';

// Colors defined outside component to prevent recreation on every render
const CHART_COLORS = ['#8b5cf6', '#ec4899', '#06b6d4', '#10b981', '#f59e0b', '#ef4444', '#84cc16', '#f97316', '#3b82f6', '#8b5cf6'];

const RankingFluctuationAfterHours: React.FC = () => {
  const { data, loading, error, refetch } = useRankingFluctuationAfterHours();

  return (
    <StockChart
      data={data}
      loading={loading}
      error={error}
      onRefetch={refetch}
      colors={CHART_COLORS}
    />
  );
};

export default RankingFluctuationAfterHours;
